export default "__VITE_ASSET__DIfpgMsz__"